import type {
  ChartType,
  SelectableChartType,
} from '../../PageConfigProvider/types/chart';

const selectableChartTypes: Record<SelectableChartType, boolean> = {
  bar: true,
  'stacked-bar': true,
  'grouped-bar': true,
  'diverging-bar': true,
  'diverging-bar-combo': true,
  line: true,
  treemap: true,
  volume: true,
  box: true,
  sankey: true,
  distribution: true,
  map: true,
  table: true,
  text: true,
  gauge: true,
  'ai-summary': true,
};

export const isSelectableChartType = (
  chartType: ChartType | undefined
): chartType is SelectableChartType =>
  selectableChartTypes[chartType as SelectableChartType];
